import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div>
      <div className="bg-primary py-3  text-[18px] text-white text-center">
        <Link
          target="_blank"
          to={"https://www.naturepower.de/shop/"}
          className="border-b border-b-white py-1"
        >
          See Our All Products{" "}
        </Link>
      </div>
    </div>
  );
};

export default Footer;
